import React, { useCallback } from 'react'
import _map from 'lodash/map'
import _find from 'lodash/find'
import { useNavigate } from 'react-router'

import AddCarPage from '../AddCarPage/AddCarPage'

const SelectCarPage = () => {
  const navigate = useNavigate()
  const savePressHandler = useCallback(() => {
    navigate('/booking')
  }, [navigate])

  return <AddCarPage onAddCar={savePressHandler} />
}

export default React.memo(SelectCarPage)
